import { eksmoBP } from 'Lib/bp/bp';
import 'Vendor/owlcarousel/owl.carousel.min';
import { getW } from 'Lib/w/w';
import { speed } from 'Lib/speed/speed';

const $slider = $('.filter-slider');
const cSliderOn = 'owl-carousel';

function setSlider(e, width) {
    if (width > eksmoBP.smMin) {
        $slider.each(function () {
            $(this).trigger('destroy.owl.carousel')
                .removeClass(cSliderOn)
                .addClass(cSliderOn)
                .owlCarousel({
                    smartSpeed: speed * 2,
                    margin: 12,
                    nav: true,
                    items: 7,
                    dots: false,
                    sArrows: '.filter-slider__arrows',
                    navClass: ['filter-slider__prev arrow arrow_prev arrow_shadow', 'filter-slider__next arrow arrow_next arrow_shadow'],
                    navText: ['', ''],
                    responsive: {
                        1920: {
                            items: 8,
                        },
                    },
                });
        });
    } else {
        $slider.trigger('destroy.owl.carousel');
    }
}

setSlider(false, getW());
$('body').on('eksmoResizeWidth', setSlider);